const isLogin = () => !!localStorage.getItem('token')
const getToken = () => localStorage.getItem('token')

export {
  isLogin,
  getToken
}
